import { render, staticRenderFns } from "./KoioteTank.vue?vue&type=template&id=57e67040&scoped=true&lang=true"
import script from "./KoioteTank.vue?vue&type=script&lang=js"
export * from "./KoioteTank.vue?vue&type=script&lang=js"
import style0 from "./KoioteTank.vue?vue&type=style&index=0&id=57e67040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e67040",
  null
  
)

export default component.exports